import { NOT_CAPTURED } from "../../lib/vocabulary";

const STYLES = {
  Positive: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Neutral: "bg-slate-100 text-slate-700 border-slate-300",
  Negative: "bg-red-50 text-red-700 border-red-200",
  "Not Available": "bg-amber-50 text-amber-700 border-amber-200",
};

/**
 * PATTERN A. `{feedback || "—"}` rendered a dash inside Neutral badge chrome —
 * a grey pill with a dot, sitting where every other row carries a rating. A
 * visit whose feedback was never recorded read as a recorded neutral one. A
 * missing rating is not a rating: it gets no chrome and says so in words.
 */
export default function FeedbackBadge({ feedback, size = "md" }) {
  const clean = typeof feedback === "string" ? feedback.trim() : feedback;
  const sz = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-0.5";

  if (clean === null || clean === undefined || clean === "") {
    return (
      <span
        className={`${sz} text-callisto-muted whitespace-nowrap`}
        data-testid="feedback-not-captured"
      >
        {NOT_CAPTURED}
      </span>
    );
  }

  const cls = STYLES[clean] || STYLES.Neutral;
  return (
    <span
      className={`inline-flex items-center gap-1 ${sz} font-semibold rounded-full border ${cls} whitespace-nowrap`}
      data-testid={`feedback-badge-${clean.replace(/\s+/g, "-").toLowerCase()}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-60" />
      {clean}
    </span>
  );
}
